import { axiosInstance } from "../utils/axiosInterceptor";

export const GetOrganizersListService = async (data = {}) => {
  return await axiosInstance.post("organizer_list", data);
};

export const CreateOrganizerService = async (data) => {
  return await axiosInstance.post("add_organizer", data);
};

export const GetOrganizerDropdown = async () => {
  return await axiosInstance.post("organizer_dropdown_list");
};

export const UpdateOrganizerAccessLevel = async (data) => {
  return await axiosInstance.post("update_organizer_access_level", data);
};

export const getCountryDialCodes = async () => {
  return await axiosInstance.get("get_countries");
};

export const toggleOrganizerStatus = async (user_id, status) => {
  return await axiosInstance.post("toogle_orgnaizer_status", {
    user_id,
    status,
  });
};

export const getOrganizerEvents = async (user_id) => {
  return await axiosInstance.post("get_organizer_events", { user_id });
};
